<!-- Input para busca no autocomplete -->
<div class="search-container">
  <input
    type="text"
    placeholder="buscar ativos, PACs.."
    #autocompleteInput
    [(ngModel)]="searchValue"
    (keyup)="onSearchValueChange($event)"
    class="form-control input-text custom-form-group search"
  />
  <!-- icone de busca caso input estiver vazio -->
  <i class="fa fa-search search--icon"></i>
  <button
    class="search--clear-button"
    *ngIf="searchValue"
    (click)="resetSearch(); $event.stopPropagation()"
  >
    <i class="fa fa-times search--clear-icon"></i>
  </button>
</div>
